import ajax from "../utils/request";
const actressApi = {
  /********************************女优列表*********************************** */
  // 获取女优列表
  getActressList(params) {
    return ajax({
      url: "/actress",
      type: "get",
      params: params,
    });
  },
  // 添加女优
  addActress(params) {
    return ajax(
      {
        url: "/actress",
        type: "post",
        params: params,
      },
      true
    );
  },
  // 批量修改女优帖子价格
  updManyActressVidPrice(params) {
    return ajax(
      {
        url: "/actress/update/price",
        type: "put",
        params: params,
      },
      true
    );
  },
  // 删除女优
  delActress(params) {
    return ajax({
      url: "/actress",
      type: "delete",
      params: params,
    });
  },
  // 修改女优
  updateActress(params) {
    return ajax(
      {
        url: "/actress",
        type: "put",
        params: params,
      },
      true
    );
  },
  // 获取女优筛选项
  getActressOptions() {
    return ajax({
      url: "/actressopt/searchOptions",
      type: "get",
    });
  },
  /********************************女优筛选项列表*********************************** */
  // 获取女优筛选项列表
  getActressoptList(params) {
    return ajax({
      url: "/actressopt/list",
      type: "get",
      params: params,
    });
  },
  // 添加女优筛选项
  addActressopt(params) {
    return ajax(
      {
        url: "/actressopt/create",
        type: "post",
        params: params,
      },
      true
    );
  },
  // 删除女优筛选项
  delActressopt(params) {
    return ajax({
      url: "/actressopt/delete",
      type: "post",
      params: params,
    });
  },
  // 修改女优筛选项
  updateActressopt(params) {
    return ajax(
      {
        url: "/actressopt/update",
        type: "post",
        params: params,
      },
      true
    );
  },
  /********************************众筹列表*********************************** */
  // 获取众筹列表
  getCrowdFundingList(params) {
    return ajax({
      url: "/crowd_funding_config/list",
      type: "get",
      params: params,
    });
  },
  // 添加众筹
  addCrowdFunding(params) {
    return ajax(
      {
        url: "/crowd_funding_config/create",
        type: "post",
        params: params,
      },
      true
    );
  },
  // 删除众筹
  delCrowdFunding(params) {
    return ajax({
      url: "/crowd_funding_config/delete",
      type: "post",
      params: params,
    });
  },
  // 修改众筹
  updateCrowdFunding(params) {
    return ajax(
      {
        url: "/crowd_funding_config/update",
        type: "post",
        params: params,
      },
      true
    );
  },
  // 重新上架
  reactiveCrowdFunding(params) {
    return ajax(
      {
        url: "/crowd_funding_config/reactive",
        type: "post",
        params: params,
      },
      true
    );
  },
};

export default actressApi;
